import { render } from "./BlogsView.vue?vue&type=template&id=5dab12bb&scoped=true"
import script from "./BlogsView.vue?vue&type=script&lang=js"
export * from "./BlogsView.vue?vue&type=script&lang=js"

import "./BlogsView.vue?vue&type=style&index=0&id=5dab12bb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dab12bb"]])

export default __exports__